import classNames from 'classnames';

// compStyles - об'єкт з ключами кастомних стилів для компонента, наприклад:
// {
//     title: 'titleClass',
//     subtitle: { color: 'black' },
//     text: { className: 'textClass', color: 'red' }
// }

// Приймає compStyles і повертає стилі або порожній об'єкт
export const generateCompStyle = (compStyles) => {
    if (!compStyles) return {};
    const keys = Object.keys(compStyles);
    return keys.reduce((accum, key) => {
        let result = {};
        if (typeof compStyles[key] === 'string') {
            return { ...accum, [key]: {} };
        } else if (typeof compStyles[key] === 'object') {
            Object.keys(compStyles[key] || {}).forEach((keyVal) => {
                if (keyVal !== 'className' && keyVal !== 'style') {
                    result[keyVal] = compStyles[key][keyVal];
                } else if (keyVal === 'style') {
                    result = { ...compStyles[key][keyVal], ...result };
                }
            });
        }
        if (!Object.keys(result).length) {
            return { ...accum };
        }
        return { ...accum, [key]: result };
    }, {});
};

// Приймає compStyles і повертає клас або порожній рядок
export const generateCompClasses = (compStyles) => {
    if (!compStyles) return {};

    const keys = Object.keys(compStyles);
    return keys.reduce((accum, key) => {
        if (typeof compStyles[key] === 'string') {
            return { ...accum, [key]: compStyles[key] };
        } else if (typeof compStyles[key] === 'object') {
            if (compStyles[key]?.['className']) {
                return { ...accum, [key]: compStyles[key]['className'] };
            }
        }
        return { ...accum, [key]: '' };
    }, {});
};

// Приймає compStyles і префікс (для використання кілька разів в одному компоненті, необовязково) повертає об'єкт, як цей:
// {
//     classes: {
//         title: 'titleClass',
//         subtitle: '',
//         text: 'textClass'
//     },
//     stylers: {
//         title: {},
//         subtitle: { color: 'black' },
//         text: { color: 'red' }
//     }
// };
export const generateCompStylers = (compStyles, prefix = '') => {
    return {
        [`stylers${prefix}`]: generateCompStyle(compStyles),
        [`classes${prefix}`]: generateCompClasses(compStyles)
    };
};

// Приймає compStyles і один, або кілька ключів, для яких треба отримати кастомні стилі у форматі пропсів style і className
export const getStylePropsFunc = (compStyles, ...keys) => {
    const { stylers, classes } = generateCompStylers(compStyles);
    if (keys.length) {
        return {
            style: keys.reduce((ac, key) => ({ ...ac, ...(stylers[key] || {}) }), {}),
            className: classNames(keys.map((key) => classes[key]))
        };
    }
    return {};
};

// Приймає одну із властивостей compStyles, для якої треба отримати кастомні стилі у форматі пропсів style і className
export const generateStylers = (compStyle) => {
    if (!compStyle) return { className: '', style: {} };
    if (typeof compStyle === 'string') {
        return { className: compStyle, style: {} };
    } else if (typeof compStyle === 'object') {
        return {
            className: compStyle.className,
            style: Object.keys(compStyle).reduce((acc, item) => {
                if (item !== 'className') {
                    return { ...acc, [item]: compStyle[item] };
                }
                return acc;
            }, {})
        };
    }
    return { className: '', style: {} };
};
